import * as RadixSwitch from "@radix-ui/react-switch";

export function Switch({
  checked,
  onCheckedChange,
  disabled,
  "aria-label": ariaLabel,
}: {
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  disabled?: boolean;
  "aria-label"?: string;
}) {
  return (
    <RadixSwitch.Root
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      aria-label={ariaLabel}
      className="relative inline-flex shrink-0 transition-colors disabled:opacity-60"
      style={{
        width: 51,
        height: 31,
        borderRadius: 999,
        background: checked ? "var(--system-green)" : "var(--fill-primary)",
      }}
    >
      <RadixSwitch.Thumb
        className="block transition-transform"
        style={{
          width: 27,
          height: 27,
          margin: 2,
          borderRadius: 999,
          background: "#FFFFFF",
          boxShadow: "0 2px 4px rgba(0,0,0,0.18)",
          transform: checked ? "translateX(20px)" : "translateX(0)",
        }}
      />
    </RadixSwitch.Root>
  );
}
